import React from "react";
import "../App.css";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Moment from "moment";
import "primeicons/primeicons.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { Paginator } from "primereact/paginator";
import Role from "../helpers/role";
import Popover from "react-bootstrap/Popover";
import FileSaver from "file-saver";
import API from "../helpers/api";
import axios from "axios";
import swal from "sweetalert";

let userRole = localStorage.getItem("UserRoles");

class ReportCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first: 0,
      modalIsOpen: false,
      Name: "",
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  updatePopover(props) {
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label>Update</label>
        </Popover.Content>
      </Popover>
    );
  }

  render() {
    const { totalRecords, pageSize, GetCrewPhoto, arraylist } = this.props;
    return (
      <div className="pb-3">
        {this.renderCardPendingData()}
        {totalRecords !== 0 ? (
          <div className="custom-paginator">
            <Paginator
              first={this.state.first}
              rows={pageSize}
              totalRecords={totalRecords}
              onPageChange={(e) => this.onPaginatorChange(e)}
            ></Paginator>
          </div>
        ) : (
          <div
            className="card"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div class="container">
              <h6 className="resource-list-title no-item-card">
                !-- No Items to Display --!
              </h6>
            </div>
          </div>
        )}
      </div>
    );
  }

  onPaginatorChange(event) {
    this.setState({
      first: event.first,
    });
    const { setUpdatedState } = this.props;
    setUpdatedState(event.page + 1);
  }
  downloadDocument(attachmentDetail) {
    const { dispatch } = this.props;
    var str = attachmentDetail.fileUrl;
    var result = str.substring(0, str.lastIndexOf("/"));
    var n = result.lastIndexOf("/");
    var guid = result.substring(n + 1);
    var extension = str.split(".").pop();
    var filename = guid + "." + extension;
    var reportfilename = attachmentDetail.shipName + "_" + Moment(new Date()).format("DD-MM-YYYY HH:mm");
    /*  var g = str.lastIndexOf("/");
     var downloadfilename = str.substring(g + 1); */
    //console.log(guid, filename);
    let url = `${API.DownloadReport}?fileName=${filename}&guid=${guid}`;
    axios
      .get(url, { responseType: "blob" })
      .then((response) => {
        let blob = "";
        blob = new Blob([response.data], { type: response.data.type });
        FileSaver.saveAs(blob, reportfilename);
      })
      .catch((error) => {
        swal("Error!", "Something went wrong. Please try again.", "warning");
        console.log(error);
        dispatch({
          type: "DownloadFailure",
          error: "ERROR",
        });
      });
  }

  renderCardPendingData = () => {
    const { arraylist, deleteReport } = this.props;
    return arraylist && arraylist.length
      ? arraylist.map((item, index) => {
        return (
          <div
            className="card mb-1"
            style={{
              overflow: "hidden",
              position: "relative",
              marginBottom: "5px",
            }}
          >
            <div className="p-3">
              <div className="resource-list-auth-date">
                <div className="row">
                  <div className="col-md-10 col-sm-10 col-10 col-m-auto">
                    <div className="row px-3">
                      <div className="col-sm-4 col-md-4 pb-2">
                        <span>
                          <strong>Ship Name : </strong>
                          <span className="italicFont ">
                            {item ? item.shipName : ""}
                          </span>
                        </span>
                      </div>
                      <div className="col-sm-5 col-md-5 pb-2">
                        <span>
                          <strong>From Date : </strong>
                          <span className="italicFont">
                            {item ? Moment(item?.fromDate).format("DD-MM-YYYY") : ""}
                          </span>
                        </span>
                      </div>
                      <div className="col-sm-3 col-md-3 pb-2">
                        <span>
                          <strong>To Date : </strong>
                          <span className="italicFont">
                            {item ? Moment(item?.toDate).format("DD-MM-YYYY") : ""}
                          </span>
                        </span>
                      </div>
                      <div className="col-sm-4 col-md-4 pb-2">
                        <span>
                          <strong>Created Date: </strong>
                          <span className="italicFont">
                            {" "}
                            {item
                              ? Moment(
                                new Date(Date.parse(item.createdDate))
                              ).format("DD-MM-YYYY")
                              : ""}
                          </span>
                        </span>
                      </div>
                      <div className="col-sm-5 col-md-5 pb-2">
                        <span>
                          <strong>Action By: </strong>
                          <span className="italicFont ">
                            {item?.actionBy}
                          </span>
                        </span>
                      </div>
                      <div className="col-sm-3 col-md-3 pb-2">
                        <span>
                          <strong>Status : </strong>

                          {item && item?.status === 0 ? (
                            <button className="pending-button italicFont">
                              PENDING
                            </button>
                          ) : item?.status === 1 ? (
                            <button className="pending-button processing-button italicFont">
                              PROCESSING
                            </button>
                          ) : (
                            <button class="completed-button italicFont">
                              COMPLETED
                            </button>
                          )}
                        </span>
                      </div>
                      <div className="col-sm-12 col-md-12 pb-2">
                        <span>
                          <strong>Remarks: </strong>
                          <span className="italicFont ">{item?.remarks}</span>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-2 col-md-2 col-lg-2 col-m-auto text-right d-flex justify-content-end">
                    <div
                      className="text-center">
                      <i
                        className="fa fa fa-download ml-1 click px-1"
                        aria-hidden="true"
                        onClick={() => this.downloadDocument(item)}
                        style={{
                          color: `${item?.status === 2 ? "#1a3464" : "grey"
                            }`,
                          fontSize: "1.8rem",
                          pointerEvents: `${item?.status === 2 ? "block" : "none"
                            }`,

                        }}
                      ></i>

                      <a
                        href={item?.fileUrl}
                        target="_blank"
                        className="link-colors pl-2"
                        style={{
                          pointerEvents: `${item?.status === 2 ? "block" : "none"
                            }`
                        }}
                      >
                        <i
                          className="fa fa-eye click m-1 px-1"
                          aria-hidden="true"
                          style={{
                            color: `${item.status === 2 ? "#1a3464" : "grey"
                              }`,
                            fontSize: "1.8rem",
                          }}
                        ></i>
                      </a>
                      {userRole == Role.staff || userRole == Role.client || userRole == Role.consultant || userRole == Role.mmpl || userRole == Role.clientuser
                        ? (<></>) : (
                          <i
                            className="fa fa-trash click px-1"
                            aria-hidden="true"
                            onClick={() => deleteReport(item)}
                            style={{
                              color: "#1a3464",
                              fontSize: "1.8rem",
                            }}
                          ></i>
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })
      : null;
  };
}

function mapStateToProps(state) {
  return {
    GetCrewPhoto: state.CrewManagementReducer.GetCrewPhoto || "",
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ReportCard)
);
